export const ADS_COMMAND_CENTER_ENABLED =
  String(process.env.REACT_APP_ADS_COMMAND_CENTER_ENABLED || "false")
    .toLowerCase() === "true";
